import { insertIntoDataLayer } from '../../data-layer/insert-into-data-layer';

/**
 * GAに送るイベントのカテゴリー
 * @see https://github.com/Findy/Yuffie/issues/7005#issuecomment-1909394837
 */
export type GaSendEventCategory =
  | 'Web Vitals'
  | 'Next.js custom metric'
  | 'setting_account' // アカウント連携
  | 'setting_block' // ブロック設定
  | 'setting_desired_condition' // 転職意欲・希望条件
  | 'setting_notification' // 通知設定
  | 'setting_personality' // あなたの人物像
  | `setting_profile_${
      | 'annual_income'
      | 'ai_usage'
      | 'basic_info'
      | 'bio'
      | 'educational_background'
      | 'latest_development_result'
      | 'resume'
      | 'vision'
      | 'jobs'
      | 'management_jobs'
      | 'self_recommended_skills'
      | 'work_histories'
      | 'english_skill'
      | 'certifications'}` // プロフィール
  | 'setting_resume' // 職務経歴書の出力
  | 'setting_user_success_plus' // ユーザーサクセスプラス
  | 'change_notification' // 通知設定
  | `change_notification_${string}`
  | 'career_motivation_modal' // 転職意欲モーダル
  | 'user_tel' // 電話番号入力
  | 'findy_event' // イベント
  | 'findy_events' // イベントアーカイブ一覧
  | 'message' // メッセージ
  | 'pickup' // 特集ページ
  | 'us_lp' // US特設ページ
  | 'skill_deviation_v2.1' // スキル偏差値v2.1
  | 'skill_deviation_v3' // スキル偏差値v3
  | 'coty2023' // コントリビューション・オブ・ザ・イヤー2023
  | 'coty2024-mid' // コントリビューション・オブ・ザ・イヤー2024中間発表
  | 'omikuji2025' // おみくじ2025
  | 'twitter_ad'
  | 'input'
  | 'popup'
  | 'keep' // お見送り
  | 'link'
  | 'like' // いいかも
  | 'share'
  | 'register'
  | 'notice' // お知らせ
  | 'google_ad'
  | 'page_view'
  | 'sign_up_with_google_account'
  | 'click_influence_score_button_in_home_upper' // Homeの発信力レベルを測定するの内部リンク押下数;
  | 'kyujin_usersuccess'; // 求人ページ ユーザーサクセス

export interface GaSendEventParams {
  event?: string;
  category: GaSendEventCategory;
  action: string;
  label?: string;
  stringValue?: string;
  nonInteraction?: boolean;
  value?: number;
  userId?: string | number;
  /**
   * @see insertIntoDataLayer
   */
  gclid?: string | null;
}

const gaSendEventParamsObj: { userId?: number } = {
  userId: undefined,
};

// ログイン、ログアウト時のみで実行する
export function setUserIdToGaSendEventObj(userId?: number) {
  gaSendEventParamsObj.userId = userId;
}

/**
 * @see {@link https://tagmanager.google.com/#/container/accounts/1081788091/containers/6857758/workspaces/181/tags/162}
 */
export function gaSendEvent({
  event = 'eventTracking',
  category,
  label = undefined,
  value = 0,
  stringValue,
  action,
  nonInteraction = false,
  userId,
  gclid,
}: GaSendEventParams) {
  const adjustedParamsUserId =
    typeof userId === 'number' ? String(userId) : userId;
  const adjustedObjUserId =
    typeof gaSendEventParamsObj.userId === 'number'
      ? String(gaSendEventParamsObj.userId)
      : gaSendEventParamsObj.userId;

  insertIntoDataLayer({
    event,
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    eventValue: value,
    eventStringValue: stringValue,
    eventNonInteraction: nonInteraction,
    userId: adjustedParamsUserId ?? adjustedObjUserId,
    gclid,
  });
}
